export const statusList = [
  { value: 0, name: "Scheduled" },
  { value: 1, name: "In progress" },
  { value: 2, name: "Completed" },
  { value: 3, name: "Cancelled" },
  { value: 4, name: "Confirmed" },
  { value: 5, name: "Scheduled" },
  { value: 6, name: "Reschedule Requested" },
  { value: 7, name: "Phlebo Assigned" },
  { value: 8, name: "Pickup" },
  { value: 9, name: "Sample Collected" },
  { value: 10, name: "Sample Received" },
  { value: 11, name: "Report Generated" },
  { value: 12, name: "Successful HRA" },
  { value: 13, name: "Successful PRC" },
  { value: 14, name: "Declined" },
  { value: 15, name: "Not eligible" },
  { value: 16, name: "Not answered" },
  { value: 17, name: "Not answered - 3 attempts" },
  { value: 18, name: "Call later" },
  { value: 19, name: "Not reachable" },
  { value: 20, name: "Request to lab" },
  { value: 21, name: "No show" },
  { value: 22, name: "Lab visited" },
];

export function getStatusName(statusCode) {
  const status = statusList.find((s) => s.value === statusCode);
  return status ? status.name : "Unknown Status";
}

export function getStatusColor(status) {
  switch (status) {
    case 1: // In progress
      return {
        background: "#fff9e3",
        color: "#ffbd2d",
      };
    case 2: // Completed
    case 0: // Scheduled
    case 11: // Report Generated
      return {
        background: "rgba(239, 124, 1, 0.1)",
        color: "#ef7c01",
      };
    case 3: // Cancelled
    case 21: // No Show
      return {
        background: "rgba(48, 197, 63, 0.1)",
        color: "rgba(48, 197, 63, 1)",
      };
    case 4: // Confirmed
    case 14: // Declined
    case 15: // Not eligible
      return {
        background: "rgba(0, 0, 0, 0.1)",
        color: "black",
      };
    default:
      return {
        background: "rgba(239, 124, 1, 0.1)",
        color: "#ef7c01",
      };
  }
}
